"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusOptions = exports.rowsPerPageOptions = exports.ownershipTypeOptions = exports.columns = void 0;
var statusOptions = [
    { key: "all", label: "All" },
    { key: "active", label: "Active" },
    { key: "inactive", label: "Inactive" },
];
exports.statusOptions = statusOptions;
/** ATOC-2 §4: the four Lease Ownership Types, for the filter dropdown. */
var ownershipTypeOptions = [
    { key: "all", label: "All types" },
    { key: "Corporate", label: "Corporate" },
    { key: "Franchised", label: "Franchised" },
    { key: "Subleased", label: "Subleased" },
    { key: "Simple", label: "Simple" },
];
exports.ownershipTypeOptions = ownershipTypeOptions;
var rowsPerPageOptions = [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
var columns = [
    { name: "NAME", uid: "name" },
    // ATOC-1 C4: "Please adjust the tenant management table to include the trading as name as the second column."
    { name: "TRADING AS", uid: "tradingAsName" },
    // ATOC-2 §4: derived from the leases, never captured.
    { name: "OWNERSHIP", uid: "leaseOwnershipType" },
    { name: "REG. NUMBER", uid: "registrationNumber" },
    { name: "TENANT CODE", uid: "tenantCode" },
    { name: "AREA NUMBER", uid: "areaNumber" },
    { name: "CONTACT", uid: "contactDetails" },
    { name: "STATUS", uid: "status" },
    { name: "CREATED", uid: "createdAt" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
